import React, { useEffect } from "react";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import { getAllCompanies } from "../../../../../redux/companySlice/companySlice";
import { getAllContracts } from "../../../../../redux/contractSlice/contractSlice";

export default function Counters() {
  const dispatch = useDispatch();
  const { allCompanies } = useSelector((state) => state.company);
  const { allContracts } = useSelector((state) => state.contract);
  let totalVisits = allContracts?.reduce((total, contract) => total + contract.maintenance_visits, 0);
  useEffect(() => {
    dispatch(getAllContracts());
    dispatch(getAllCompanies());
  }, [dispatch]);
  return (
    <>
      <div className="counters row justify-content-center align-items-center mb-5">
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">الشركات</p>
                <p className="fs-2 mb-0 highlight">
                  <CountUp end={allCompanies?.length} duration={2} />
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-building "></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">العقود</p>
                <p className="fs-2 mb-0 highlight">
                  <CountUp end={allContracts?.length} duration={2} />
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-file-signature "></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">الزيارات</p>
                <p className="fs-2 mb-0 highlight">
                  <CountUp end={totalVisits} duration={2} />
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-eye "></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
